var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sc-user-input--button-icon-wrapper"},[_c('IconBase',{attrs:{"color":_vm.color,"width":"20","height":"20","view-box":"2.24 2.24 15.52 15.52","icon-name":_vm.tooltip}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }